import type { CreditTransactionSource } from 'shared-models/browser';

// Canonical Hebrew tender label: cash, or the credit acquisition source (manual / device / terminal).
export const creditMethodLabel = (
  method: string | null | undefined,
  source: CreditTransactionSource | null | undefined,
  terminalName?: string | null,
): string => {
  if (method === 'cash') {
    return 'מזומן';
  }
  if (method === 'tenbis') {
    return 'תן ביס';
  }
  if (method === 'house_account') {
    return 'חשבון בית';
  }
  switch (source) {
    case 'manual':
      return 'אשראי ידני';
    case 'top':
      return 'מכשיר';
    case 'pinpad':
      return terminalName ?? 'אשראי';
    default:
      return 'אשראי';
  }
};

// Same mapping keyed by a chosen tender kind (POS method picker has no terminal-name context).
export const tenderKindLabel = (kind: 'cash' | 'tenbis' | CreditTransactionSource): string =>
  kind === 'cash' || kind === 'tenbis' ? creditMethodLabel(kind, null, null) : creditMethodLabel('credit', kind, null);
